<template>
  <Tab @close="removeCurrent">
    <template #toolbar-help>
      <v-btn class="tw-mr-2" fab text x-small :title="$t('dashboard.help.show')" @click="showHelp(menu,page)">
            <span class="mr-1">
              <v-icon color="primary" x-small>fa fa-question</v-icon>
            </span>
      </v-btn>
    </template>
    <template #toolbar-items>
      <!-- ------------------------ pages ------------------------ -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'url'"
        icon="fa-link"
        name="url"
      ></TabToolbarButton>
      <!-- ------------------------ params ------------------------ -->
      <TabToolbarButton
        v-model="page"
        :menu="menu"
        :selected="page === 'params'"
        icon="fa-cogs"
        name="params"
      ></TabToolbarButton>
    </template>
    <template #container>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :timeout="snackbarTimeout"
        :multi-line="true"
        text
        outlined
        tile
        app
        top
      >
        {{ snackbarText }}
        <template #action>
          <v-btn icon @click="snackbar = false">
            <v-icon :color="snackbarColor" small>fa-times</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
      <!-- ------------------------ params ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="manager/suggestions/params/page" name="params">
        <template #websiteWrapper>
          <WebsiteWrapper @selected="selectWebsiteParams" @back="params.website_id = 0" :verified="2" :plan="1" mandatory>
          </WebsiteWrapper>
        </template>
        <template #content>
          <div v-if="params.website_id <= 0">
            {{ $t("suggestions.params.form.website_not_selected") }}
          </div>
          <template v-else>
            <v-row>
              <v-col cols="12">
                <div class="tw-mt-4 tw-font-semibold">
                  {{ $t("suggestions.params.form.wanted_title") }}
                </div>
              </v-col>
              <v-col cols="12" md="8">
                <span>{{ $t("suggestions.params.form.wanted_label") }}</span>
                <v-switch
                  v-model="params.wanted"
                  :disabled="!params.website_id > 0"
                  :label="
                    params.wanted
                      ? 'Oui, les suggestions sont proposées à vos visiteurs'
                      : 'Non, les suggestions ne sont pas proposées à vos visiteurs'
                  "
                  inset
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <div class="tw-mt-4 tw-font-semibold">
                  {{ $t("suggestions.params.form.exclude") }}
                </div>
                <v-text-field
                  v-model="exclude"
                  :label="$t('suggestions.params.form.exclude_word')"
                  :placeholder="$t('suggestions.params.form.exclude_word_placeholder')"
                  class="mt-2"
                  @keypress.enter="excludeWord"
                >
                  <template #append-outer>
                    <v-btn :title="$t('suggestions.params.form.exclude_word_add')" color="primary" @click="excludeWord">
                      &crarr;
                    </v-btn>
                  </template>
                </v-text-field>

                <v-select
                  v-model="domain"
                  :items="domains"
                  :disabled="domains.length <= 0"
                  :label="$t('suggestions.params.form.exclude_domains')"
                  item-text="host"
                  item-value="host"
                  @change="excludeDomain"
                >
                </v-select>

                <v-chip-group column>
                  <v-chip v-for="word in excludeList" :key="word" close @click:close="removeExcludedWordFromList(word)">
                    {{ word }}
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>

            <v-btn small :disabled="!params.website_id > 0" class="mt-8" color="primary" @click="paramsSend()">
              {{ $t("suggestions.params.bt.send") }}
            </v-btn>
            <!--            <v-btn small :disabled="!params.website_id > 0" class="tw-mt-4 tw-ml-4" @click="filterClear">-->
            <!--              {{ $t("suggestions.params.bt.clear") }}-->
            <!--            </v-btn>-->
          </template>
        </template>
      </TabPage>
      <!-- ------------------------ url ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="manager/urls/page" name="url">
        <template #websiteWrapper>
          <WebsiteWrapper @selected="selectWebsiteUrls" @back="selectedWebsite = {}" :verified="2" :plan="0" mandatory>
          </WebsiteWrapper>
        </template>
        <template #content>
          <div v-if="!selectedWebsite.hasOwnProperty('id')">
            {{ $t("urls.url.website_not_selected") }}
          </div>

          <template v-else>
            <!--            <div v-html="$options.filters.pretty(urlsDatatableItems)"></div>-->
            <v-snackbar
              :value="success.length > 0"
              color="green"
              @close="clearSuccess"
              :multi-line="true"
              text
              outlined
              tile
              app
              bottom
              right
            >
              <b>{{ success }}</b>
              <template v-slot:action>
                <v-icon color="green" small @click="clearSuccess">fas fa-times</v-icon>
              </template>
            </v-snackbar>

            <v-snackbar
              :timeout="-1"
              :value="errors.length > 0"
              color="red"
              :multi-line="true"
              text
              outlined
              tile
              app
              bottom
              right
              @close="clearErrors"
            >
              <b>{{ $tc("urls.url.errors.alert", errors.length) }}</b>
              <ul>
                <li v-for="(error, i) in errors" :key="i">&bullet; {{ error }}</li>
              </ul>
              <template v-slot:action>
                <v-icon color="red" small @click="clearErrors">fas fa-times</v-icon>
              </template>
            </v-snackbar>

            <v-row>
              <v-col>
                <h2 class="font-weight-bold mb-2">{{ $t("urls.url.search_label") }}</h2>
                <v-text-field
                  v-model="urlsSearch"
                  :disabled="hasNotWebsiteSelected"
                  :label="$t('urls.url.search')"
                  :title="hasNotWebsiteSelectedTitle"
                  single-line
                  style="pointer-events: auto;"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- Page List -->
            <v-row>
              <v-col>
                <h2 class="font-weight-bold mb-2">{{ $t("urls.url.datatable.label") }}</h2>
                <v-dialog v-model="newUrl.dialog" max-width="600" persistent>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="mt-2 text-right">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        :disabled="hasNotWebsiteSelected"
                        :title="hasNotWebsiteSelectedTitle"
                        color="primary"
                        small
                        style="pointer-events: auto;"
                      >
                        {{ $t("urls.url.new_url") }}
                      </v-btn>
                    </div>
                  </template>
                  <v-card>
                    <v-card-title>
                      {{ $t("urls.url.new_url") }}
                    </v-card-title>
                    <v-card-text>
                      <v-slide-x-transition appear>
                        <v-alert v-if="newUrl.errors.length" color="red" dismissible text>
                          <b>{{ $tc("urls.url.errors.alert", newUrl.errors.length) }}</b>
                          <ul>
                            <li v-for="(error, i) in newUrl.errors" :key="i">&bullet; {{ error }}</li>
                          </ul>
                          <template v-slot:close>
                            <v-icon color="red" small @click="clearNewUrlErrors">fas fa-times</v-icon>
                          </template>
                        </v-alert>
                      </v-slide-x-transition>

                      <v-text-field
                        v-model="newUrl.url"
                        :label="$t('urls.url.edit_url')"
                        :prefix="prefixUrl"
                        autofocus
                        class="mt-4"
                      ></v-text-field>
                      <v-text-field
                        v-model="newUrl.title"
                        :label="$t('urls.url.edit_title')"
                        class="mt-4"
                        counter="70"
                      ></v-text-field>
                      <v-textarea
                        v-model="newUrl.description"
                        :label="$t('urls.url.edit_description')"
                        class="mt-4"
                        counter="160"
                        no-resize
                      ></v-textarea>
                      <div :title="hasNotRightSubscriptionTitle">
                        <v-autocomplete
                          v-model="newUrl.selectedKeywords"
                          :disabled="hasNotRightSubscription"
                          :items="keywords"
                          :label="$t('urls.url.edit_keywords')"
                          :loading="keywordsLoading"
                          auto-select-first
                          cache-items
                          class="mt-4"
                          counter="4"
                          deletable-chips
                          hide-selected
                          item-text="keyword"
                          item-value="id"
                          multiple
                          return-object
                          small-chips
                          @update:search-input="searchKeywords"
                        ></v-autocomplete>
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="cancelNewUrl">
                        {{ $t("urls.url.cancel_url") }}
                      </v-btn>
                      <v-btn color="primary" text @click="saveNewUrl">
                        {{ $t("urls.url.save_url") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-data-table
                  :headers="urlsDatatableHeaders"
                  :items="urlsDatatableItems"
                  :items-per-page="5"
                  :loading="urlsLoading"
                  :search="urlsSearch"
                  class="mt-4"
                  item-key="id"
                >
                  <!-- Col URL -->
                  <template v-slot:item.url="props">
                    <a
                      :href="props.item.suggestions"
                      :title="$t('urls.url.url_action')"
                      class="hover:tw-text-red-900"
                      style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 400px;display: block;"
                      target="_blank"
                    >
                      <span class="mr-1" v-html="highlightSearch(props.item.url, urlsSearch)"></span>
                      <v-icon small>fas fa-external-link-alt</v-icon>
                    </a>
                  </template>
                  <!-- Col TITRE -->
                  <template v-slot:item.title="props">
                    <v-dialog v-model="props.item.title_modal">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-on="on"
                          :title="$t('urls.url.title_action')"
                          class="tw-cursor-pointer hover:tw-text-red-900"
                          @click="openTitle(props.item)"
                          v-html="highlightSearch(props.item.title != '' ? props.item.title : '...', urlsSearch)"
                        ></div>
                      </template>
                      <v-card>
                        <v-card-title class="title">
                          {{ $t("urls.url.update_title") }}
                        </v-card-title>
                        <v-card-text>
                          <v-text-field
                            v-model="props.item.title"
                            :label="$t('urls.url.edit_title')"
                            autofocus
                            class="mt-4"
                            counter="70"
                          ></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="cancelTitle(props.item)">{{ $t("urls.url.cancel_title") }}</v-btn>
                          <v-btn text @click="saveTitle(props.item)">{{ $t("urls.url.save_title") }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <!-- Col DESCRIPTION -->
                  <template v-slot:item.description="props">
                    <v-dialog v-model="props.item.description_modal">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-on="on"
                          :title="$t('urls.url.description_action')"
                          class="tw-cursor-pointer hover:tw-text-red-900"
                          @click="openDescription(props.item)"
                          v-html="
                            highlightSearch(props.item.description != '' ? props.item.description : '...', urlsSearch)
                          "
                        ></div>
                      </template>
                      <v-card>
                        <v-card-title class="title">
                          {{ $t("urls.url.update_description") }}
                        </v-card-title>
                        <v-card-text>
                          <v-textarea
                            v-model="props.item.description"
                            :label="$t('urls.url.edit_description')"
                            autofocus
                            class="mt-4"
                            counter="160"
                            no-resize
                          ></v-textarea>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="cancelDescription(props.item)"
                            >{{ $t("urls.url.cancel_description") }}
                          </v-btn>
                          <v-btn text @click="saveDescription(props.item)"
                            >{{ $t("urls.url.save_description") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <!-- Col KEYWORDS -->
                  <template v-slot:item.keywordsString="props">
                    <div v-if="hasNotRightSubscription" :title="hasNotRightSubscriptionTitle">
                      <div v-html="highlightSearch(props.item.keywordsString, urlsSearch)"></div>
                    </div>

                    <v-dialog v-else v-model="props.item.keywords_modal">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-on="on"
                          :title="$t('urls.url.keyword_action')"
                          class="tw-cursor-pointer hover:tw-text-red-900"
                          @click="openKeywords(props.item)"
                          v-html="highlightSearch(props.item.keywordsString, urlsSearch)"
                        ></div>
                      </template>
                      <v-card>
                        <v-card-title class="title">
                          {{ $t("urls.url.update_keywords") }}
                        </v-card-title>
                        <v-card-text>
                          <v-autocomplete
                            v-model="props.item.selectedKeywords"
                            :items="keywords"
                            :label="$t('urls.url.edit_keywords')"
                            :loading="keywordsLoading"
                            auto-select-first
                            cache-items
                            class="mt-4"
                            counter="4"
                            deletable-chips
                            hide-selected
                            item-text="keyword"
                            item-value="id"
                            multiple
                            return-object
                            small-chips
                            @update:search-input="searchKeywords"
                          ></v-autocomplete>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn text @click="cancelKeywords(props.item)">{{ $t("urls.url.cancel_keywords") }}</v-btn>
                          <v-btn text @click="saveKeywords(props.item)">{{ $t("urls.url.save_keywords") }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <!-- Col SUGGESTION STATUS -->
                  <template v-slot:item.suggestionsUpdatedAt="props">
                    {{ props.item.suggestionsUpdatedAt | moment("from") }}
                  </template>
                  <!-- Col ACTIONS -->
                  <template v-slot:item.actions="{ item }">
                    <div class="sr-flex-row">
                      <v-btn :title="$t('urls.url.statistics')" icon small @click="showUrlStatistic(item)">
                        <v-icon small>fas fa-chart-bar</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="item.locked"
                        :title="$t('urls.url.unlock')"
                        icon
                        small
                        @click="unlockUrlcontent(item)"
                      >
                        <v-icon small>fas fa-lock</v-icon>
                      </v-btn>
                      <v-btn v-else :title="$t('urls.url.lock')" icon small @click="lockUrlcontent(item)">
                        <v-icon small>fas fa-lock-open</v-icon>
                      </v-btn>
                      <v-btn :title="$t('urls.url.delete_url')" icon small @click="deleteUrl(item)">
                        <v-icon small>fas fa-trash</v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </template>

          <v-dialog v-model="urlStatistic" scrollable>
            <v-card>
              <v-card-title class="tw-border-b">
                {{ $t("urls.dialogue.statistics.title") }}
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="urlStatisticsDataHeaders"
                  :items="urlStatisticsData"
                  :items-per-page="5"
                  class="mt-4"
                  item-key="id"
                >
                </v-data-table>
              </v-card-text>
              <v-card-actions class="tw-border-t">
                <v-spacer></v-spacer>
                <v-btn color="primary" small text @click="urlStatistic = false">
                  {{ $t("common.close") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </TabPage>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import WebsiteWrapper from "@/components/common/Form/WebsiteWrapper"
import { uniqBy } from "lodash"

export default {
  name: "SuggestionsParams",
  components: {
    WebsiteWrapper,
  },
  mixins: [tab],
  data: () => ({
    valid: false,
    pages: ["params", "url"],
    page: "url",
    menu: "suggestions",
    exclude: "",
    excludeList: [],
    domain: null,
    domains: [],
    excludedDomains: [],
    params: {
      exclude: "",
      wanted: true,
      website_id: 0,
    },
    snackbar: false,
    snackbarTimeout: 2000,
    snackbarText: "",
    snackbarColor: "success",
    errors: [],
    success: "",
    selectedWebsite: {},
    urlStatisticsDataHeaders: [],
    urlStatisticsData: {},
    urlStatistic: false,
    newUrl: {
      dialog: false,
      errors: [],
      url: "",
      title: "",
      description: "",
      keywordsString: "",
      selectedKeywords: [],
      keywords: [],
    },
    urls: [],
    urlsLoading: false,
    urlsSearch: "",
    urlsDatatableHeaders: [],
    urlsDatatableItems: [],
    urlOpened: -1,
    keywordsLoading: false,
    searchedKeyword: "",
    keywords: [],
    alreadySearchedKeywords: [],
  }),
  mounted() {
    this.buildUrlsDatatableHeaders()
  },
  computed: {
    prefixUrl() {
      return "https://" + this.selectedWebsite.host + "/"
    },
    hasNotWebsiteSelected() {
      return !this.selectedWebsite.hasOwnProperty("host")
    },
    hasNotWebsiteSelectedTitle() {
      return this.hasNotWebsiteSelected ? this.$t("urls.url.errors.no_selected_website") : ""
    },
    hasNotRightSubscription() {
      return !(this.selectedWebsite.hasOwnProperty("plan_id") && this.selectedWebsite.plan_id > 1)
    },
    hasNotRightSubscriptionTitle() {
      return this.hasNotRightSubscription ? this.$t("urls.url.has_not_right_plan") : ""
    },
  },
  methods: {
    fetchUrls() {
      this.$axios
        .get("/office/manager/pages/urls", {
          params: {
            id: this.selectedWebsite.id,
            host: this.selectedWebsite.host,
          },
        })
        .then(response => {
          this.urls = response.data
          this.fillUrlsDatatableItems()
        })
        .finally(() => {
          this.urlsLoading = false
        })
    },
    selectWebsiteParams(website) {
      this.urlsLoading = true
      this.selectedWebsite = website
      this.params.website_id = website.id
      this.loadWebsiteParams()
    },
    selectWebsiteUrls(website) {
      this.urlsLoading = true
      this.selectedWebsite = website
      this.params.website_id = website.id
      this.fetchUrls()
    },
    buildUrlsDatatableHeaders() {
      this.urlsDatatableHeaders = [
        {
          text: this.$t("urls.url.datatable.url"),
          align: "start",
          value: "url",
        },
        {
          text: this.$t("urls.url.datatable.title"),
          value: "title",
        },
        {
          text: this.$t("urls.url.datatable.description"),
          value: "description",
        },
        {
          text: this.$t("urls.url.datatable.keywords"),
          value: "keywordsString",
        },
        {
          text: this.$t("urls.url.datatable.suggestions_updated_at"),
          value: "suggestionsUpdatedAt",
        },
        {
          text: this.$t("urls.url.datatable.actions"),
          value: "actions",
          sortable: false,
        },
      ]
    },
    formatItemData(item) {
      let selectedKeywords = []
      let keywordsString = this.$t("urls.url.datatable.no_keywords")

      if (item.wordsgroup_id !== null) {
        keywordsString = []

        if (item.l1_f3_lemme !== null && item.l1_f3_lemme !== -1) {
          selectedKeywords.push({ id: item.l1_id, keyword: item.l1_f3_lemme })
          keywordsString.push(item.l1_f3_lemme)
        }
        if (item.l2_f3_lemme !== null && item.l2_f3_lemme !== -1) {
          selectedKeywords.push({ id: item.l2_id, keyword: item.l2_f3_lemme })
          keywordsString.push(item.l2_f3_lemme)
        }
        if (item.l3_f3_lemme !== null && item.l3_f3_lemme !== -1) {
          selectedKeywords.push({ id: item.l3_id, keyword: item.l3_f3_lemme })
          keywordsString.push(item.l3_f3_lemme)
        }
        if (item.l4_f3_lemme !== null && item.l4_f3_lemme !== -1) {
          selectedKeywords.push({ id: item.l4_id, keyword: item.l4_f3_lemme })
          keywordsString.push(item.l4_f3_lemme)
        }

        keywordsString = keywordsString.join(", ")
      }

      return {
        id: item.id,
        domain_db: item.domain_db,
        hash: item.hash,
        url: item.path === "" ? "/" : item.path,
        title: item.title ? item.title : "",
        description: item.description ? item.description : "",
        locked: item.locked ? item.locked : false,
        suggestions: "https://" + this.selectedWebsite.host + (item.path === "" ? "/" : item.path),
        suggestionsUpdatedAt: item.updated_at ? item.updated_at : item.created_at,
        selectedKeywords,
        keywordsString,
      }
    },
    fillUrlsDatatableItems() {
      let items = []

      this.urls.forEach(item => {
        items.push(this.formatItemData(item))
      })
      this.urlStatisticsDataHeaders = [
        {
          text: this.$t("urls.dialogue.statistics.datatable.date"),
          align: "start",
          value: "date_tick",
        },
        {
          text: this.$t("urls.dialogue.statistics.datatable.affichage"),
          value: "suggestions",
        },
      ]
      this.urlsDatatableItems = items
    },
    highlightSearch(haystack, needle) {
      return haystack.replace(new RegExp(needle, "g"), "<span class='primary lighten-5'>" + needle + "</span>")
    },
    searchKeywords(keyword) {
      if (!keyword || this.keywordsLoading) {
        return
      }

      if (this.alreadySearchedKeywords.some(k => k === keyword)) {
        return
      }

      this.keywordsLoading = true

      this.$axios
        .get("/office/manager/pages/keywords", {
          params: {
            keyword,
          },
        })
        .then(response => {
          this.keywords = uniqBy([...this.keywords, ...response.data], "id")
          this.alreadySearchedKeywords.push(keyword)
        })
        .finally(() => {
          this.keywordsLoading = false
        })
    },
    showUrlStatistic(item) {
      this.clearAlerts()
      this.$axios
        .post("/office/manager/pages/statistics", {
          database: item.domain_db,
          url_id: item.id,
        })
        .then(response => {
          this.urlStatisticsData = response.data
          this.urlStatistic = true
        })
    },
    deleteUrl(item) {
      this.clearAlerts()
      this.$axios
        .delete("/office/manager/pages/urls", {
          params: {
            hash: item.hash,
            host: this.selectedWebsite.host,
          },
        })
        .then(() => {
          this.urlsDatatableItems = this.urlsDatatableItems.filter(url => url.hash !== item.hash)
          this.success = this.$t("urls.url.success.delete_url")
        })
        .catch(error => {
          this.errors.push(this.translateError(error.response.data))
        })
    },
    lockUrlcontent(item) {
      this.clearAlerts()
      this.$axios
        .patch("/office/manager/pages/urls/lock", {
          hash: item.hash,
          host: this.selectedWebsite.host,
        })
        .then(() => {
          item.locked = true
          this.success = this.$t("urls.url.success.locked")
        })
        .catch(error => {
          this.errors.push(this.translateError(error.response.data))
        })
    },
    unlockUrlcontent(item) {
      this.clearAlerts()
      this.$axios
        .patch("/office/manager/pages/urls/unlock", {
          hash: item.hash,
          host: this.selectedWebsite.host,
        })
        .then(() => {
          item.locked = false
          this.success = this.$t("urls.url.success.unlocked")
        })
        .catch(error => {
          this.errors.push(this.translateError(error.response.data))
        })
    },
    openSuggestions(item) {
      window.open(item.suggestions, "_blank")
    },
    cancelNewUrl() {
      this.newUrl.dialog = false
    },
    saveNewUrl() {
      this.clearNewUrlErrors()

      if (this.newUrl.selectedKeywords.length > 4) {
        this.newUrl.errors.push(this.$t("urls.url.errors.keywords_counter"))
      }

      if (this.newUrl.errors.length > 0) {
        return
      }

      this.$axios
        .post("/office/manager/pages/urls", {
          host: this.selectedWebsite.host,
          url: this.newUrl.url,
          title: this.newUrl.title,
          description: this.newUrl.description,
          selectedKeywords: this.newUrl.selectedKeywords,
        })
        .then(response => {
          this.urlsDatatableItems.push(this.formatItemData(response.data))
          this.newUrl.dialog = false
          this.resetNewUrl()
        })
        .catch(error => {
          this.newUrl.errors.push(this.translateError(error.response.data))
        })
    },
    resetNewUrl() {
      this.newUrl.url = ""
      this.newUrl.title = ""
      this.newUrl.description = ""
      this.newUrl.keywordsString = ""
      this.newUrl.selectedKeywords = []
      this.newUrl.keywords = []
    },
    translateError(error) {
      if (error.hasOwnProperty("code")) {
        return this.$t("urls.url.errors." + error.code)
      }

      if (error.hasOwnProperty("message")) {
        return error.message
      }

      return error
    },
    clearAlerts() {
      this.clearSuccess()
      this.clearErrors()
      // this.clearNewUrlErrors()
    },
    clearSuccess() {
      this.success = ""
    },
    clearErrors() {
      this.errors = []
    },
    clearNewUrlErrors() {
      this.newUrl.errors = []
    },
    saveKeywords(item) {
      this.clearAlerts()

      if (item.selectedKeywords.length > 4) {
        this.errors.push(this.$t("urls.url.errors.keywords_counter"))
        return
      }

      this.$axios
        .patch("/office/manager/pages/urls/keywords", {
          host: this.selectedWebsite.host,
          hash: item.hash,
          selectedKeywords: item.selectedKeywords,
        })
        .then(() => {
          item.locked = true
          item.keywordsString = item.selectedKeywords.map(k => k.keyword).join(", ")
          this.success = this.$t("urls.url.success.keywords_save")
        })
        .catch(error => {
          this.errors.push(this.translateError(error.response.data))
        })
        .finally(() => (item.keywords_modal = false))
    },
    cancelKeywords(item) {
      item.keywords_modal = false
    },
    openKeywords(item) {
      this.urlOpened = this.urlsDatatableItems.findIndex(url => url.hash === item.hash)
      this.keywords = uniqBy([...this.keywords, ...item.selectedKeywords], "id")
    },
    saveTitle(item) {
      this.clearAlerts()

      this.$axios
        .patch("/office/manager/pages/urls/title", {
          host: this.selectedWebsite.host,
          hash: item.hash,
          title: item.title,
        })
        .then(() => {
          item.locked = true
          this.success = this.$t("urls.url.success.title_save")
        })
        .catch(error => {
          this.cancelTitle(item)
          this.errors.push(this.translateError(error.response.data))
        })
        .finally(() => (item.title_modal = false))
    },
    cancelTitle(item) {
      item.title = item.titleSnapshot
      item.title_modal = false
    },
    openTitle(item) {
      this.urlOpened = this.urlsDatatableItems.findIndex(url => url.hash === item.hash)
      item.titleSnapshot = item.title ? item.title : ""
    },
    saveDescription(item) {
      this.clearAlerts()

      this.$axios
        .patch("/office/manager/pages/urls/description", {
          host: this.selectedWebsite.host,
          hash: item.hash,
          description: item.description,
        })
        .then(() => {
          item.locked = true
          this.success = this.$t("urls.url.success.description_save")
        })
        .catch(error => {
          this.cancelDescription(item)
          this.errors.push(this.translateError(error.response.data))
        })
        .finally(() => (item.description_modal = false))
    },
    cancelDescription(item) {
      item.description = item.descriptionSnapshot
      item.description_modal = false
    },
    openDescription(item) {
      this.urlOpened = this.urlsDatatableItems.findIndex(url => url.hash === item.hash)
      item.descriptionSnapshot = item.description ? item.description : ""
    },
    excludeWord() {
      if (this.exclude.length <= 0) {
        return
      }

      if (this.excludeList.some(e => e === this.exclude)) {
        return
      }

      this.excludeList.push(this.exclude)
      this.exclude = ""
      this.params.exclude = this.excludeList.join("\n")
    },
    removeExcludedWordFromList(word) {
      this.excludeList = this.excludeList.filter(e => e !== word)
      this.exclude = ""
      this.params.exclude = this.excludeList.join("\n")

      if (this.excludedDomains.some(d => d.host === word)) {
        this.domains.push(this.excludedDomains.find(d => d.host === word))
        this.excludedDomains = this.excludedDomains.filter(d => d.host !== word)
      }
    },
    excludeDomain() {
      if (this.domain.length <= 0) {
        return
      }

      if (this.excludeList.some(e => e === this.domain)) {
        return
      }

      this.excludeList.push(this.domain)

      this.excludedDomains.push(this.domains.find(d => d.host === this.domain))
      this.domains = this.domains.filter(d => d.host !== this.domain)

      this.params.exclude = this.excludeList.join("\n")

      this.$nextTick(() => {
        this.domain = null
      })
    },
    loadWebsiteParams() {
      this.$axios
        .get("/office/manager/suggestions/params?website_id=" + this.params.website_id)
        .then(response => {
          this.params.exclude = response.data.exclude
          this.params.wanted = response.data.wanted
          this.domains = response.data.domains
          if (this.params.exclude.length > 0) {
            this.excludeList = this.params.exclude.split("\n")
            this.excludeList.forEach(word => {
              if (this.domains.some(d => d.host === word)) {
                this.excludedDomains.push(this.domains.find(d => d.host === word))
                this.domains = this.domains.filter(d => d.host !== word)
              }
            })
          }
        })
        .catch(() => {
          this.params.exclude = ""
          this.params.wanted = true
        })
    },
    filterClear() {
      this.params.exclude = ""
    },
    paramsSend() {
      this.$axios
        .post("/office/manager/suggestions/params", {
          website_id: this.params.website_id,
          wanted: this.params.wanted,
          exclude: this.params.exclude,
        })
        .then(() => {
          this.snackbarText = this.$t("suggestions.params.messages.sendDone")
          this.snackbarColor = "success"
          this.snackbarTimeout = 4 * 1000
          this.snackbar = true
        })
        .catch(() => {
          this.snackbarText = this.$t("suggestions.params.messages.sendError")
          this.snackbarColor = "warning"
          this.snackbarTimeout = 4 * 1000
          this.snackbar = true
        })
    },
  },
}
</script>
